import Config from 'config';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { parseXMLRequestResponse } from '../utils/util';
import { TErrMessage, TRequestError } from './types';

export type THasSignableForms = {
  result: string;
  onClose: string;
  sysMessages?: TErrMessage;
  sysException?: TErrMessage;
};

export interface IHasSignableFormsSlice {
  response: THasSignableForms | TRequestError | null;
  onClose: string | null;
}

export const fetchHasSignableFrms = createAsyncThunk<THasSignableForms | null>(
  'hasSignableFormsSlice/fetchHasSignableFrms',
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(Config.HAS_SIGNABLE_FORMS_URL());
      return parseXMLRequestResponse(response) as THasSignableForms;
    } catch (err) {
      const error = (err as TRequestError).response;
      return thunkAPI.rejectWithValue(error.data);
    }
  },
);

const hasSignableFormsSlice = createSlice({
  name: 'hasSignableFormsSlice',
  initialState: {
    response: null,
    onClose: null,
  } as IHasSignableFormsSlice,
  reducers: {
    // hasSignableFormsResult: (
    //   state,
    //   action: PayloadAction<IHasSignableFormsSlice>,
    // ) => {
    //   state.hasSignableForms = action.payload.hasSignableForms;
    //   state.onClose = action.payload.onClose;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHasSignableFrms.pending, (state, action) => {
      if (action.payload) {
        state.response = action.payload;
      }
    });
    builder.addCase(fetchHasSignableFrms.fulfilled, (state, action) => {
      if (action.payload) {
        state.response = action.payload;
      }
    });
    builder.addCase(fetchHasSignableFrms.rejected, (state, action) => {
      if (action.payload) {
        state.response = action.payload as TRequestError;
      }
    });
  },
});
export default hasSignableFormsSlice.reducer;
// export const { hasSignableFormsResult } = hasSignableFormsSlice.actions;
